module.exports = __webpack_public_path__ + "static/media/Cert IV Project Management.137dff6e.pdf";